import arrow_left from "../../../assets/icons/arrow-left.svg";
import arrow_right from "../../../assets/icons/arrow-right.svg";

// Botão que recolhe/expande o menu lateral. É um <button> de verdade (teclado,
// leitor de tela) e informa o estado em aria-expanded.
export default function BotaoColapsar({ colapsado, onClick, controla }) {
  return (
    <button
      type="button"
      className="toggle-menu"
      onClick={onClick}
      aria-expanded={!colapsado}
      aria-controls={controla}
      aria-label={colapsado ? "Expandir menu" : "Recolher menu"}
      title={colapsado ? "Expandir menu" : "Recolher menu"}
    >
      <img src={colapsado ? arrow_right : arrow_left} alt="" />
    </button>
  );
}
